import { Box } from '@eatclubcode/ec-component-library';
import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import dayjs from 'dayjs';
import { PrimaryButton } from '../../components/button/PrimaryButton';
import { isEmpty } from '../../utils/baseHelpers';
import CancelMembershipPage from './CancelMembershipPage';
import { primaryButtonStyles } from './CancelMembershipStyles';
import useStyles, { toggleGroupStyles } from './SchedulePageStyles';
import { ToggleGroup } from './ToggleGroup/ToggleGroup';

const SchedulePage = ({ currentStep, totalSteps, onContinue, callDate, setCallDate, isSaving }) => {
  const classes = useStyles();

  const [error, setError] = useState('');

  // Reset error on change
  useEffect(() => {
    setError('');
  }, [callDate]);

  const upcomingWeeks = useMemo(() => {
    const today = dayjs();
    const dayList = [
      today.add(1, 'days'),
      today.add(2, 'days'),
      today.add(3, 'days'),
      today.add(4, 'days'),
      today.add(5, 'days'),
      today.add(6, 'days'),
      today.add(7, 'days'),
    ];

    return dayList
      .filter((weekday) => weekday.weekday() !== 0 && weekday.weekday() !== 6)
      .map((weekday) => ({
        value: weekday.format('YYYY-MM-DD'),
        label: (
          <Box className={classes.dateContent}>
            <Box>{weekday.format('dddd')}</Box>
            <Box className={classes.dateNumber}>{weekday.format('Do')}</Box>
            <Box className={classes.dateMonth}>{weekday.format('MMM')}</Box>
          </Box>
        ),
      }));
  }, []);

  const handleContinue = () => {
    if (isEmpty(callDate)) {
      setError('You must select a date');
    } else {
      onContinue();
    }
  };

  return (
    <CancelMembershipPage
      currentStep={currentStep}
      totalSteps={totalSteps}
      isSaving={false}
      footerLeft={
        <PrimaryButton style={primaryButtonStyles} onClick={handleContinue} loading={isSaving}>
          Confirm
        </PrimaryButton>
      }
    >
      <Box className={classes.mainContent}>
        <Box className={classes.title}>
          When are you able to have a phone call with your Account Manager?
        </Box>
        <ToggleGroup
          label=''
          value={callDate}
          onSelect={setCallDate}
          items={upcomingWeeks}
          style={toggleGroupStyles}
          singleChoice
        />
      </Box>
      {error && <Box style={{ color: 'red', paddingBottom: '12px' }}>{error}</Box>}
    </CancelMembershipPage>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SchedulePage);
